import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

type IssueLinkFieldValue = {
	outwardIssue: { key: string };
	type: { name: string };
};

type JiraIssueLinkFieldProps = {
	fieldValue: unknown;
};

const styles = cssMap({
	inline: {
		paddingInlineStart: token('space.100'),
		paddingInlineEnd: token('space.100'),
	},
});

// Temporary read-only placeholder for the IssueLinkField
export const JiraIssueLinkField = ({ fieldValue }: JiraIssueLinkFieldProps): JSX.Element | null => {
	if (!fieldValue) {
		return null;
	}
	if (Array.isArray(fieldValue)) {
		const fieldValueAsIssueLinks = fieldValue as IssueLinkFieldValue[];

		return (
			<Inline space="space.050" alignBlock="center" xcss={styles.inline}>
				<Text
					maxLines={1}
					size="medium"
				>{`${fieldValueAsIssueLinks.map((item) => item.outwardIssue.key).join(', ')}`}</Text>
			</Inline>
		);
	}
	const fieldValueAsIssueLink = fieldValue as IssueLinkFieldValue;
	return (
		<Inline space="space.050" alignBlock="center" xcss={styles.inline}>
			<Text maxLines={1} size="medium">{`${fieldValueAsIssueLink.outwardIssue.key}`}</Text>
		</Inline>
	);
};
